






















































import { UseModal } from "@/components/root/modal";
import Vue from "vue";
import ConnectionSupportModalVue from "../modals/ConnectionSupportModal.vue";
export default Vue.extend({
  props: ["source"],
  setup(props) {
    const show_connection_help_modal = () => {
      // @ts-ignore
      const icon = props.source.runtime.icon;
      UseModal().show(ConnectionSupportModalVue, { icon });
    };
    return {
      show_connection_help_modal,
    };
  },
});
